import { Environment } from '@wheere-front/customer-shared-util';

export const environment: Environment = {
  production: true,
  type: 'develop',
  url: 'https://customer.dev.wheere.tech',
  api: {
    tracker: 'https://inside.dev.wheere.tech/api/tracker',
    gateway: 'https://inside.dev.wheere.tech/api/gateway',
    site: 'https://inside.dev.wheere.tech/api/site',
    websocket: 'https://inside.dev.wheere.tech/api',
  },
  keycloak: {
    issuer: 'https://auth.dev.wheere.tech',
    realm: 'wheere',
    clientId: 'frontend-customer',
  },
};
